import React from 'react';
import StickyContainer from '../../Componant/Bonus-Ui/Sticky';

const Sticky = () => {
  return (
    <div className='page-body'>
      <StickyContainer />
    </div>
  );
};

export default Sticky;
